import { render, staticRenderFns } from "./keywordList.vue?vue&type=template&id=d3724f5a&scoped=true&"
import script from "./keywordList.vue?vue&type=script&lang=js&"
export * from "./keywordList.vue?vue&type=script&lang=js&"
import style0 from "./keywordList.vue?vue&type=style&index=0&id=d3724f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3724f5a",
  null
  
)

export default component.exports